import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';


@Injectable({providedIn: 'root'})
export class AtividadeService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    create(data: any)  {
        return this.http.post(`${SCAMP_API.accountApiV1}/atividades`, data, {headers : this.account.composeHeaders()});
    }

    uploadPhotos(data: any): Observable<any[]>  {
        return this.http.post<any[]>(`${SCAMP_API.accountApiV1}/atividades/upload-photos`, data, 
        {headers : this.account.composeHeaders()});
    }


    read(id: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/atividade/${id}`, {headers : this.account.composeHeaders()});
    }

    getAtividadeDetailsAsync(mesano: string, areatecnicaid: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/atividades/${mesano}/${areatecnicaid}`, 
        {headers : this.account.composeHeaders()});
    }



    update(id: number, data: any) {
        return this.http.put(`${SCAMP_API.accountApiV1}/atividade/${id}`, data, {headers : this.account.composeHeaders()});
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/atividade/${id}`, {headers : this.account.composeHeaders()});
    }

    list(equipamentoId: number): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/atividades/${equipamentoId}`, {headers : this.account.composeHeaders()});
    }


    search(data: any): Observable<any> {
        return this.http.post(`${SCAMP_API.accountApiV1}/atividade-search`, data, {headers : this.account.composeHeaders()});
    }

    updateDataProximaExecucao(equipamentoId, periodicidadeId, proximaExecucaoAnterior, proximaExecucao): Observable<boolean> {
        return this.http.get<boolean>(`${SCAMP_API.accountApiV1}/atividades/update-data/${equipamentoId}/${periodicidadeId}/${proximaExecucaoAnterior}/${proximaExecucao}`, {headers : this.account.composeHeaders()});
    }

    removePlanoExecucao(equipamentoId, periodicidadeId): Observable<boolean> {
        return this.http.get<boolean>(`${SCAMP_API.accountApiV1}/atividades/delete-plano/${equipamentoId}/${periodicidadeId}`,
         {headers : this.account.composeHeaders()});
    }


    exportarCalendarioMensalToExcel(mes: string, areaTecnicaId: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/atividades/calendario-mensal/excel/${mes}/${areaTecnicaId}`,
            { headers: this.account.composeHeaders() });
    }



}
